import { chartColors } from '@/_shared/tools/theme.js';
import { formatNumber } from '@this/shared/dist/tools/number-format.js';
import { ReactECharts, type ReactEChartsProps } from './react-echarts.js';

type DonutChartProps = {
    data: {
        name: string;
        value: number;
    }[];
    label: string;
};

export function DonutChart({ data, label }: DonutChartProps) {
    const total = data.reduce((sum, d) => sum + d.value, 0);

    const option: ReactEChartsProps['option'] = {
        graphic: {
            elements: [
                {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    z: 999,
                    style: {
                        text: formatNumber(total, 0, 'compact'),
                        fontSize: 30,
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: 'bold',
                    },
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '58%',
                    z: 999,
                    style: {
                        text: label,
                        fontFamily: '"Open Sans", sans-serif',
                        fontSize: 10,
                        fill: 'rgb(113, 113, 122)',
                    },
                },
            ],
        },
        tooltip: {
            formatter: (params) => {
                if (Array.isArray(params)) {
                    throw new Error('Params is an array');
                }

                const value = params.value as number;
                const percentage = value ? (value / total) * 100 : 0;

                return `${params.name}: ${formatNumber(value, 0, 'compact')} (${(percentage).toFixed(2)}%)`;
            },
        },
        series: [
            {
                type: 'pie',
                radius: ['65%', '90%'],
                label: {
                    show: false,
                },
                labelLine: {
                    show: false,
                },
                data: data.map(({ name, value }, index) => ({
                    name,
                    value,
                    itemStyle: {
                        color: chartColors[`chartColor${index + 1}` as keyof typeof chartColors],
                    },
                })),
            },
        ],
    };

    return <ReactECharts option={option} />;
}
